export default __webpack_public_path__ + "static/inter-all-900-normal-5ca43c0ffda2d44d5beec641b82c4ae9.woff";